var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.67 16.94a1.22 1.22 0 0 0-1.22 1.21V20a1.57 1.57 0 0 1-1.57 1.57H4.12A1.57 1.57 0 0 1 2.55 20v-1.85a1.22 1.22 0 0 0-2.43 0V20a4 4 0 0 0 4 4h15.76a4 4 0 0 0 4-4v-1.85a1.21 1.21 0 0 0-1.21-1.21Z",
    transform: "scale(2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 0a1.94 1.94 0 0 0-1.94 1.94V11a.25.25 0 0 1-.25.25H7.15a1 1 0 0 0-.73 1.6l4.85 5.58a1 1 0 0 0 1.46 0l4.85-5.58a1 1 0 0 0-.73-1.6h-2.66a.25.25 0 0 1-.25-.25V1.94A1.94 1.94 0 0 0 12 0Z",
    transform: "scale(2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d6bec24e.svg";
export { ForwardRef as ReactComponent };